const scrollOptions = {
  behavior: 'smooth'
}

const install = Vue => {
  Vue.prototype.$navScroll = hash => {
    const target = hash
      ? document.querySelector(hash)
      : document.querySelector('body')

    if (target) {
      target.scrollIntoView(scrollOptions)
    }
  }
}

export default install
